// store/uiStore.ts
import { defineStore } from 'pinia';
import { ModalTypes } from '@/types/enums';

interface MenuItem {
  id: number;
  attributes: {
    link: string;
    label: string;
  };
  subItems?: MenuItem[];
}

interface UIState {
  popupMessage: string | null;
  modalType: ModalTypes; // changed type from string to ModalTypes
  modalMessage: string | null;
  mobileMenu: boolean;
  darkMode: boolean;
  liveSales: boolean;
  mainMenuItems: MenuItem[];
  loadingScreenActive: boolean;
}

export const useUIStore = defineStore('uiStore', {
  state: (): UIState => ({
    popupMessage: null,
    modalType: ModalTypes.INACTIVE,  // set default to SIGNIN
    modalMessage: null,
    loadingScreenActive: false,
    mobileMenu: false,
    darkMode: true, // Initially set to light mode
    liveSales: false, // Initially set to false
    mainMenuItems: [  // Hardcoded main menu items
      //{ id: 0, attributes: { link: "/sales/black-friday-sale", label: "Black Friday" } },
      { id: 1, attributes: { link: "/", label: "Products" } },
      //{ id: 1, attributes: { link: "/sales/black-friday-sale", label: "BlackFriday" } },
      { id: 2, attributes: { link: "/downloads", label: "Downloads" } },
      { id: 3, attributes: { link: "/shop", label: "Shop" } },
      { id: 4, attributes: { link: "/support", label: "Support" } }
    ],
  }),
  actions: {
    setPopupMessage(message: string) {
      console.log('setPopupMessage:', message);
      this.popupMessage = message;
    },
    openLoadingScreen() {
     // console.log('openLoadingScreen');
     // this.loadingScreenActive = true;
    },
    setModalType(new_type: string, new_message: string | null = null) {
      console.log('setModalType in uiStore:', new_type, 'with message:', new_message);
      this.modalType = new_type;
      if(this.modalType == ModalTypes.INACTIVE) {
        this.modalMessage = null;
      }
      else
      {
        this.modalMessage = new_message;
      }     
    },
    setMobileMenu(new_state: boolean) {
      this.mobileMenu = new_state;
    },
    toggleDarkMode() {
      console.log('toggleDarkMode in uiStore');
      this.darkMode = !this.darkMode; // toggle the current state
    },
    setDarkMode(state: boolean) {
      this.darkMode = state; // set the dark mode to a specific state
    },
    // Actions related to liveSales
    toggleLiveSales() {
      this.liveSales = !this.liveSales; // toggle the current state of liveSales
    },
    setLiveSales(state: boolean) {
      this.liveSales = state; // set the liveSales to a specific state
    }
  }
});
